import { FC } from "react";
import classNames from "classnames";

import InputField from "../InputField/InputField";
import Button from "../Button/Button";
import { FileExportIcon, SearchIcon } from "../icons";
import type { SearchExportToolbarProps } from "./types";

import styles from "./SearchExportToolbar.module.css";

const DEFAULT_PLACEHOLDER = "Search";
const DEFAULT_ARIA_LABEL = "Search";

const SearchExportToolbar: FC<SearchExportToolbarProps> = ({
  searchValue,
  onSearchChange,
  onExportClick,
  placeholder = DEFAULT_PLACEHOLDER,
  searchAriaLabel = DEFAULT_ARIA_LABEL,
  className,
}) => (
  <div className={classNames(styles["search_export_toolbar"], className)}>
    <div className={styles["search_export_toolbar__search_wrap"]}>
      <span className={styles["search_export_toolbar__search_icon"]} aria-hidden>
        <SearchIcon />
      </span>
      <InputField
        type="search"
        placeholder={placeholder}
        value={searchValue}
        onChange={onSearchChange}
        className={styles["search_export_toolbar__search"]}
        aria-label={searchAriaLabel}
      />
    </div>
    <Button
      className={classNames(
        styles["search_export_toolbar__button"],
        styles["search_export_toolbar__export_button"]
      )}
      type="button"
      typeStyle="empty"
      Icon={FileExportIcon}
      label="Export"
      size="sm"
      onClick={onExportClick}
    />
  </div>
);

export default SearchExportToolbar;
